import AsyncStorage from "@react-native-async-storage/async-storage";

const KEY = "blockStatsAgg_v1";

/** @returns {Promise<{ dayKey: string, blockCount: number }>} */
async function readRaw() {
  try {
    const s = await AsyncStorage.getItem(KEY);
    if (!s) return { dayKey: "", blockCount: 0 };
    const o = JSON.parse(s);
    return {
      dayKey: typeof o.dayKey === "string" ? o.dayKey : "",
      blockCount: Number.isFinite(o.blockCount) ? o.blockCount : 0,
    };
  } catch {
    return { dayKey: "", blockCount: 0 };
  }
}

function todayKey() {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

/** Increment local “blocks today” counter (no URL stored). */
export async function incrementBlocksToday(by = 1) {
  const day = todayKey();
  const cur = await readRaw();
  const count = cur.dayKey === day ? cur.blockCount + by : by;
  await AsyncStorage.setItem(KEY, JSON.stringify({ dayKey: day, blockCount: count }));
  return count;
}

export async function getBlocksTodayCount() {
  const day = todayKey();
  const cur = await readRaw();
  return cur.dayKey === day ? cur.blockCount : 0;
}

export async function resetBlocksToday() {
  await AsyncStorage.setItem(KEY, JSON.stringify({ dayKey: todayKey(), blockCount: 0 }));
}
